import React, {useContext, useState} from 'react';
import {MapContext} from "../../../context/MapContext";

/**
 * Layer control Layout on Layer Switcher
 * @returns {JSX.Element}
 * @constructor
 */
const LayerLayoutControl = ({
                                layer
                            }) => {
    const {mapContext, dispatch} = useContext(MapContext);
    const [visibilityLayer, setVisibilityLayer] = useState(
        (mapContext.map &&
            mapContext.map.getLayoutProperty(layer.id, 'visibility') &&
            mapContext.map.getLayoutProperty(layer.id, 'visibility') === 'visible') || false
    )

    const toggleVisibilityLayer = () => {
        if (mapContext.map) {
            let visibilityProperty
            // toggle layer visibility by changing the layout object's visibility property
            if (visibilityLayer) {
                visibilityProperty = 'none'
                setVisibilityLayer(false)
            } else {
                visibilityProperty = 'visible'
                setVisibilityLayer(true)
            }
            //Store visibility property on layer by context
            mapContext.map.setLayoutProperty(layer.id, 'visibility', visibilityProperty);
            dispatch({
                type: 'TOGGLE_VISIBILITY_LAYER', layerVisivility: {[layer.id]: visibilityProperty}
            })
        }
    }

    return (
        <div
            onClick={() =>
                !(layer && layer.metadata && layer.metadata.lockvisibility) &&
                toggleVisibilityLayer()
            }
            className={"col-12 row layer-items"}>
            <div className={'form-check toggle-layer'}>
                <input className="form-check-input" type="checkbox"
                       id={`check-visibility-${layer.id}}`}
                       checked={visibilityLayer}
                       disabled={(layer && layer.metadata && layer.metadata.lockvisibility) || false}
                       readOnly

                />
            </div>
            <div className="legend-layer">
                {mapContext.map && mapContext.map.getPaintProperty(layer.id, 'fill-color') &&
                <svg width="20" height="20">
                    <rect width="20" height="20" style={{
                        fill: mapContext.map && mapContext.map.getPaintProperty(layer.id, 'fill-color'),
                        stroke: "white"
                    }}/>
                </svg>
                }
            </div>
            <div className="global-text-left-invert label-layer" htmlFor={`check-visibility-${layer.id}}`}>
                {(layer && layer.metadata.layername) || 'Nom inconnu'}
            </div>
        </div>
    );
};

export default LayerLayoutControl;